import React from 'react';
import { Steps } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';

interface ProgressProps {
  currentStage: number;
  onStepClick: (step: number) => void;
}

const STAGE_ROUTES: Record<string, string> = {
  'individual-1': '/review-hub/pm/individual',
  'individual-2': '/review-hub/level1/individual',
  'individual-3': '/review-hub/level2/individual',
  'individual-4': '/review-hub/stack/individual',
  'team-1':       '/review-hub/pm/team',
  'team-2':       '/review-hub/level1/team',
  'team-3':       '/review-hub/level2/team',
};

const Progress: React.FC<ProgressProps> = ({ currentStage, onStepClick }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isTeam = location.pathname.includes('team');
  const type = isTeam ? 'team' : 'individual';

  const handleStepClick = (stepIndex: number) => {
    const route = STAGE_ROUTES[`${type}-${stepIndex}`];
    if (route) navigate(route);
    else onStepClick(stepIndex);
  };

  const steps = [
    { title: 'Nominated' },
    { title: 'Manager Review' },
    { title: 'Unit Head Review' },
    { title: 'ELT Review' },
    { title: 'ELT Calibration' },
    { title: 'Final Review' },
  ];

  return (
    <Steps
      size="small"
      current={currentStage}
      style={{ padding: '8px 0' }}
      items={steps.map((s, i) => ({
        title: (
          <span
            onClick={() => handleStepClick(i)}
            style={{
              cursor: i < currentStage ? 'pointer' : 'default',
              color: i === currentStage ? '#481558' : i < currentStage ? '#52c41a' : '#bfbfbf',
              fontWeight: i === currentStage ? 600 : 400,
              fontSize: 12,
            }}
          >
            {s.title}
          </span>
        ),
      }))}
    />
  );
};

export default Progress;
